/**
 * PartnerHeroSteps – Drei-Schritte-Erklärung für neue Partner.
 * Separat ausgelagert, damit PartnerOverview unter 300 Zeilen bleibt.
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sparkles } from "lucide-react";

const STEPS = [
  {
    n: 1,
    title: "Teile deinen Link oder Code",
    text: "Schick deinen persönlichen Link an Kolleginnen, Eltern, Kita-Teams – oder nenn einfach den Rabattcode.",
  },
  {
    n: 2,
    title: "Deine Kontakte sparen 10%",
    text: "Mit dem Code MUSIK10 bekommen sie automatisch 10% Rabatt auf jede Mitgliedschaft, Ausbildung oder Webinar-Buchung.",
  },
  {
    n: 3,
    title: "Du bekommst 20% Provision",
    text: "Auf jeden Kauf. Bei monatlichen Mitgliedschaften sogar jeden Monat aufs Neue, solange das Abo läuft.",
  },
];

const PartnerHeroSteps = () => (
  <Card className="border-primary/30 bg-gradient-to-br from-primary/5 via-background to-background">
    <CardHeader>
      <div className="flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-primary" />
        <CardTitle className="text-2xl">Willkommen im Partnerprogramm</CardTitle>
      </div>
      <CardDescription>
        Empfehle MusiKonzept und verdiene Provision – ganz einfach in drei Schritten:
      </CardDescription>
    </CardHeader>
    <CardContent>
      <div className="grid gap-4 md:grid-cols-3">
        {STEPS.map((s) => (
          <div key={s.n} className="rounded-lg border bg-card p-4">
            <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary font-semibold text-primary-foreground">
              {s.n}
            </div>
            <div className="font-semibold">{s.title}</div>
            <p className="mt-1 text-sm text-muted-foreground">{s.text}</p>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default PartnerHeroSteps;
